import { store } from "../stores/store"
import DataLoading from "./DataLoading"

class Translations {
  all = {}

  init() {
    DataLoading.translations.forEach(t => {
      if(t.key) {
        if(this.all[t.key]) {
          window.alert("Error translations.xlsx : 2 keys identical (" + t.key + ")")
        }
        this.all[t.key] = t

      }
    })

  }


  get chartSeparator() {
    return store.language === "fr" ? " : " : ": "
  }

  // on accède à cette function via store.t
  get(key, language, return_english = true) {
    if(!this.all[key]) {
      // console.log("translation non existant for", key)
      return null
    }

    if(this.all[key][language]) {
      // normal
      return this.all[key][language]
    }

    if (this.all[key]["en"] && return_english) {
      // return english si existe
      // console.log("translation non existant for", key, "in", language, "but exists in english")
      return this.all[key]["en"]
    }

    // console.log("translation non existant for", key, "in", language, "nor in english")
    return null

  }



}

export default new Translations()
